import React, { useCallback, useEffect, useState } from "react";
import { Formik, Form } from "formik";
import CardHeader from "@commons/businesscardHeader";
import Column from "@components/column";
import Fields from "@components/fields";
import Row from "@components/row";
import Wrapper from "@components/wrapper";
import Button from "@components/button";
import { toast } from "react-toastify";
import generalSettings from "@apis/generalSettings";

const Refer = () => {
  const [initialValues, setInitialValues] = useState({
    "earnings-to-referrer": "",
    "earnings-to-referee": "",
  });
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState<any>(null);

  const fetchReferSettings = useCallback(async () => {
    try {
      const res = await generalSettings.getByKey({
        state: "refer",
        id: "customer-refer-setting", // Changed to match your API key
        showErr: false,
      });
      if (res && res.infos) {
        console.log("Refer settings response:", res);
        setInitialValues({
          "earnings-to-referrer": res.infos.sharedCodeAmount?.toString() || "", // Map to sharedCodeAmount
          "earnings-to-referee": res.infos.useCodeAmount?.toString() || "", // Map to useCodeAmount
        });
        setExist(res);
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchReferSettings();
  }, [fetchReferSettings]);

  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      const payload = {
        key: "customer-refer-setting", // Match the API key
        infos: {
          sharedCodeAmount: parseInt(values["earnings-to-referrer"]) || 0, // Map to sharedCodeAmount
          useCodeAmount: parseInt(values["earnings-to-referee"]) || 0, // Map to useCodeAmount
        },
      };

      if (exist?.id) {
        await generalSettings.update({
          state: "refer",
          data: payload,
          id: exist.id,
        });
        toast.success("Refer settings updated successfully!");
      } else {
        await generalSettings.create({ state: "refer", data: payload });
        toast.success("Refer settings saved successfully!");
      }

      fetchReferSettings();
    } catch (err) {
      console.error(err);
      toast.error("Failed to update refer settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <CardHeader title="Customer Refer Settings" />
          <Wrapper>
            <Column>
              <Row>
                <Fields.Input
                  name="earnings-to-referrer"
                  label="Earnings to referral who shared the code"
                  placeholder="Rs 100"
                  type="number" // Added for better input handling
                />
                <Fields.Input
                  name="earnings-to-referee"
                  label="Earnings to referral who used the code"
                  placeholder="Rs 100"
                  type="number" // Added for better input handling
                />
              </Row>

              <div style={{ marginTop: 16, textAlign: "right" }}>
                <Button
                  title={exist ? "Update" : "Save"}
                  type="submit"
                  loading={loading}
                  justify="end"
                />
              </div>
            </Column>
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default Refer;
